"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Modal_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Modal"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Header_1 = __importDefault(require("./Header/Header"));
var Content_1 = __importDefault(require("./Content/Content"));
var Footer_1 = __importDefault(require("./Footer/Footer"));
/**
 * The Modal is utilized to convey a logical arrangement of content and actions in a layout that covers the rest of a page's layout. It is best for content that requires user input or confirmation.
 * @child ./Header/Header.tsx
 * @child ./Content/Content.tsx
 * @child ./Footer/Footer.tsx
 */
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        var _a = this.props, closeIcon = _a.closeIcon, className = _a.className, cleanedProps = __rest(_a, ["closeIcon", "className"]);
        var closeIconOutput = this.props.closeIcon ? React.createElement("span", { className: "close-icon-wrap" },
            React.createElement(Icon_1.default, { root: "common", name: "close", className: "modal-close" })) : false;
        return (React.createElement(Modal_1.default, __assign({}, cleanedProps, { closeIcon: closeIconOutput, dimmer: true, className: this.genModalClasses() }), this.props.children));
    };
    Modal.prototype.genModalClasses = function () {
        var classes = '';
        if (this.props.className) {
            classes += this.props.className + " ";
        }
        if (this.props.closeIcon) {
            classes += 'has-close-icon';
        }
        return classes;
    };
    Modal.Header = Header_1.default;
    Modal.Content = Content_1.default;
    Modal.Footer = Footer_1.default;
    Modal.defaultProps = {
        size: 'large',
        closeOnDimmerClick: true,
        closeOnDocumentClick: true
    };
    return Modal;
}(React.Component));
exports.default = Modal;
